/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: null,
    name: "Dashboard",
    slug: "dashboard",
    icon: "AirplayIcon",
    i18n: "Página Inicial",
    submenu: [
      {
        url: '/Inicio',
        name: "Analytics",
        icon: "AirplayIcon",
        slug: "paginainicial",
        i18n: "Inicio",
      },
      /*{
        url: '/Admin',
        name: "eCommerce",
        icon: "AirplayIcon",
        slug: "paginaconciliacao",
        i18n: "Admin",
      },
      {
        url: '/Finance',
        name: "eCommerce",
        icon: "AirplayIcon",
        slug: "paginaconciliacao",
        i18n: "Finance",
      },*/
    ]
  },
  {
    header: "Pagamentos",
    icon: "SendIcon",
    i18n: "Cadastros",
    url: null,
    slug: "pagamentos",
    name: "pagamentos",
  },
  {
    url: "/cadastro/franquia/lista",
    name: "Enviar Pagamento",
    slug: "enviarpagamento",
    icon: "ArrowUpRightIcon",
    i18n: "Franquias",
  },
  {
    url: "/cadastro/provedor",
    name: "Enviar Pagamento",
    slug: "enviarpagamento",
    icon: "ArrowUpRightIcon",
    i18n: "Provedores",
  },
  {
    url: "/cadastro/seguradora",
    name: "Pagar Fatura",
    slug: "enviarpagamento",
    icon: "FigmaIcon",
    i18n: "Seguradoras",
  },
  {
    url: "/cadastro/produto",
    name: "Recarga Celular",
    slug: "receberpagamento",
    icon: "ArrowDownRightIcon",
    i18n: "Produtos",
  },
  {
    url: "/cadastro/usuario",
    name: "Pagamento Boleto",
    slug: "pagamentoboleto",
    icon: "MinusSquareIcon",
    i18n: "Usuários",
  },
  {
    header: "Investimentos",
    icon: "BarChart2Icon",
    i18n: "Operações",
  },
  {
    url: "/operacao/realizar",
    name: "Realizar Investimento",
    slug: "realizarinvestimento",
    icon: "SearchIcon",
    i18n: "Realizar Operação",
  },
  {
    header: "Crédito",
    icon: "CreditCardIcon",
    i18n: "Lotes",
  },
  {
    url: "/operacao/realizar/lote",
    name: "Solicitar Investimento",
    slug: "solicitarinvestimento",
    icon: "DollarSignIcon",
    i18n: "Cobrança em lote",
  },
  {
    url: "/cancelamento/realizar/lote",
    name: "Meus Investidores",
    slug: "meusinvestidores",
    icon: "GitPullRequestIcon",
    i18n: "Cancelamento em lote",
  },
  {
    header: "Realizar TED",
    icon: "ShareIcon",
    i18n: "Relatórios",
  },
  {
    url: "/relatorio/transacoes",
    name: "Minhas Contas",
    slug: "minhascontas",
    icon: "BookIcon",
    i18n: "Transações",
  },
  {
    url: "/relatorio/calendario",
    name: "Outra Titularidade",
    slug: "outratitularidade",
    icon: "SendIcon",
    i18n: "Calendário",
  },
  /*{
    url: "/ted/contas/outra",
    name: "Outra Titularidade",
    slug: "outratitularidade",
    icon: "SendIcon",
    i18n: "Previsto/Efetivado",
  },*/
  {
    url: "/relatorio/transacoes/lote",
    name: "Outra Titularidade",
    slug: "outratitularidade",
    icon: "SendIcon",
    i18n: "Lotes",
  },
  {
    url: "/relatorio/transacoes/operador",
    name: "Outra Titularidade",
    slug: "outratitularidade",
    icon: "SendIcon",
    i18n: "Transações por Operador",
  },
{
    header: "Realizar DOC",
    icon: "LoaderIcon",
    i18n: "Gerenciamento",
  },
  {
    url: "/relatorio/assinaturas",
    name: "Minhas Contas",
    slug: "minhascontas",
    icon: "BookIcon",
    i18n: "Assinaturas",
  },
  {
    url: "/relatorio/assinaturas/falha",
    name: "Outra Titularidade",
    slug: "outratitularidade",
    icon: "SendIcon",
    i18n: "Falhas",
  },
{
    header: "Bitcoin",
    icon: "CpuIcon",
    i18n: "Financeiro",
  },
  {
    url: "/movimento/financeiro",
    name: "Enviar Bitcoin",
    slug: "outratitularidade",
    icon: "SendIcon",
    i18n: "Movimentos Financeiros",
  },
  {
    url: "/movimento/financeiro/extrato",
    name: "Enviar Bitcoin",
    slug: "outratitularidade",
    icon: "SendIcon",
    i18n: "Extrato",
  },
  /*{
    url: "/bitcoin/transferir",
    name: "Enviar Bitcoin",
    slug: "outratitularidade",
    icon: "SendIcon",
    i18n: "Conciliação Rede",
  },
  {
    url: "/bitcoin/transferir",
    name: "Enviar Bitcoin",
    slug: "outratitularidade",
    icon: "SendIcon",
    i18n: "Conciliação ChargeBack Rede",
  },*/

]
